import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--events"
export default class extends Controller {
  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const eventName = event.currentTarget.dataset.eventName;
    const url = event.currentTarget.dataset.url;
    const target = document.getElementById(targetId);
    const modalController = this.application.getControllerForElementAndIdentifier(target, "modal");

    target.getElementsByClassName("modal-dialog_event-name-text")[0].textContent = eventName;
    target.getElementsByClassName("modal-dialog_event-copy")[0].href = url;
    modalController.show();
  }

  // 隠しフォームを送信する処理
  submitPreviewForm(event) {
    event.preventDefault(); // デフォルトのリンク動作を防止

    // 隠しフォームとそのフィールドを取得
    const form = document.querySelector("#hidden-preview-form");
    const eventIdInput = document.querySelector("#hidden-preview-event-id");
    const promoterIdInput = document.querySelector("#hidden-preview-promoter-id");

    // HTMLデータ属性から値を取得してフォームフィールドを更新
    const eventId = event.currentTarget.dataset.eventId;
    const promoterId = event.currentTarget.dataset.promoterId;

    if (form && eventId && promoterId) {
      eventIdInput.value = eventId;
      promoterIdInput.value = promoterId;

      // フォーム送信
      form.target = "_blank";
      form.submit();
    } else {
      console.error("フォームまたは必要なデータが見つかりません");
    }
  }
}
